import { render, staticRenderFns } from "./ContractorItem.vue?vue&type=template&id=b7b19a8a&"
import script from "./ContractorItem.vue?vue&type=script&lang=ts&"
export * from "./ContractorItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports